import { observable, action } from "mobx";
import { post } from "../services/ajax.service";

class PharmacyRebateStore {


  @observable quarterly_rebate_summary = [];
  @observable total_rebate_by_category = [];
  @observable rebate_by_theraclass = [];


  @observable action = false;
  @observable recent = false;
  @observable errors = {};
  @observable url = "/api/v1/pharmacyRebateActions";



  @action setErrors = () => {
    this.errors = {};
  };
  @action setAction = action => {
    this.action = action;
  };


  @action getDataforPDF = async data => {
    // this.user_all_groups = [];
    try {
      let response = await post(
        `${this.url}/getDataforPDF`,
        data
      );

      this.quarterly_rebate_summary = response.data.quaterly_rebate_summary;
      this.total_rebate_by_category = response.data.quarterly_category_data;
      this.rebate_by_theraclass = response.data.quaterly_rebate_by_thera_classes;

      return response.data;
    } catch (err) {
      console.log(err);
    }
  };

}

export default PharmacyRebateStore;
